const TIER_1 = 'TIER_1';
export default TIER_1;
